import React, { useMemo , useEffect ,useState} from "react";
import { Card, CardBody, CardTitle, Col, Row,Alert } from "reactstrap";
import TableContainer from "../../../../Components/Common/TableContainer";
import { Link } from "react-router-dom";
import { subscribeToTokenRefresh } from "../../../../helpers/Refreshfile";
import withRouter from "../../../../Components/Common/withRouter";
import avatar from "../../../../assets/images/users/avatar-1.jpg"
import axios from "axios"
// import defaultUserImg from "../../../assets/images/defaultuserimgdark.png"
import defaultUserImg from "../../../../assets/images/defaultuserimgdark.png"
import { APIClient } from "../../../../helpers/api_helper";
const api = new APIClient();
const baseUrl = process.env.REACT_APP_BASE_URL;

interface column {
  header: string;
  accessorKey?: string;
  accessorFn?: (row: any) => string;
  enableColumnFilter: boolean;
  enableSorting: boolean;
  cell?: (info: any) => React.ReactNode;
}

const LatestBooking = () => {


  const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
  const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
      if (reason === "clickaway") { return; }
      setAlertMsgg({ ...alertMsgg, open: false })
  };
  const [showloader, setshowloader] = useState(true);



    const columns: column[] = useMemo(
            () => [
                {
                  header: 'S.No',
                  enableColumnFilter: false,
                  enableSorting: false, 
                  cell: ({ row, table }) => {
                      return row.index + 1;
                  },
                },
                {
                    header: 'Customer Info',
                    accessorFn: (row: any) => {
                      const first_name = row?.cust?.user?.first_name || '';
                      const email = row?.cust?.user?.email || '';
                      return `${first_name} ${email}`;
                    },
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: (info: any) => {
                      const row = info.row.original;
                      const first_name = row?.cust?.user?.first_name;
                      const email = row?.cust?.user?.email;
                      const attachment = row?.cust?.user?.profile_pic;
                  
                      return (
                        <div className="d-flex align-items-center">
                          <img
                              src={attachment ? `${baseUrl}${attachment}` : defaultUserImg}
                              alt="User"
                              width="50"
                              height="50"
                              className="rounded-circle object-fit-cover"
                              style={{ marginRight: '10px' }}
                              onError={(e) => {
                                  e.currentTarget.onerror = null;
                                  e.currentTarget.src = defaultUserImg;
                              }}
                          />
                          <div>
                              <div className="fw-medium">{first_name || "No first name"}</div>
                              <div className="font-size-12">{email || "No email"}</div>
                          </div>
                      </div>
                      );
                    }
                  },
                {
                  header: 'Expert Info',
                  accessorFn: (row: any) => {
                    const first_name = row?.expert?.user?.first_name || '';
                    const email = row?.expert?.user?.email || '';
                    return `${first_name} ${email}`;
                  },
                  enableColumnFilter: false,
                  enableSorting: true,
                  cell: (info: any) => {
                    const row = info.row.original;
                    const first_name = row?.expert?.user?.first_name;
                    const email = row?.expert?.user?.email;
                    const attachment = row?.expert?.user?.profile_pic;
                
                    return (
                      <div className="d-flex align-items-center">
                          <img
                              src={attachment ? `${baseUrl}${attachment}` : defaultUserImg}
                              alt="User"
                              width="50"
                              height="50"
                              className="rounded-circle object-fit-cover"
                              style={{ marginRight: '10px' }}
                              onError={(e) => {
                                  e.currentTarget.onerror = null;
                                  e.currentTarget.src = defaultUserImg;
                              }}
                          />
                          <div>
                              <div className="fw-medium">{first_name || "No first name"}</div>
                              <div className="font-size-12">{email || "No email"}</div>
                          </div>
                      </div>
                    );
                  }
                },
                
                {
                    header: 'Phone',
                    accessorFn: (row) => row?.expert?.user?.phone || 'N/A',
                    enableColumnFilter: false,
                    enableSorting: true,
                },
                // {
                //     header: 'Booking Date',
                //     accessorKey: 'seldate',
                //     enableColumnFilter: false,
                //     enableSorting: true,
                // },
                {
                    header: 'Booking Date',
                    accessorKey: 'seldate',
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: ({ row }) => {
                      const date = row.original.seldate;
                      const time = row.original.seltimes?.hour;
                      return time ? `${date} / ${time}` : `${date}`;
                    }             
                },
                {
                    header: 'Category',
                    accessorKey: 'expert.category',
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: ({ row }: any) => {
                        const category = row.original.expert?.category;
                        if (category) {
                          const subcategories = row.original.expert?.subcategory.name;
                    
                          return (
                            <>
                              {category.name} <br /> {subcategories}  
                            </>
                          );
                        }
                        return 'No category available';  
                      },
                },
                {
                  header: 'Price',
                  accessorFn: (row) => row?.expert_price || 0,
                  enableColumnFilter: false,
                  enableSorting: true,
                },
                {
                    header: 'status',
                    accessorFn: (row) => row?.status || 'N/A',
                    enableColumnFilter: false,
                    enableSorting: true,
                },
            ],
            []
        );


    const [bookings, setBookings] = useState<any[]>([]);
    const fetch_admin_bookings = async () => {
        try {
          setshowloader(true)
          const response = await api.create(`/bookings/admin_bookings`,{});
          if (response.status === 'SENT') {
            setshowloader(false)
            setBookings(response.bookings);
          }
        } catch (error:any) {
          if (error.response) {
              if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
              }
              else if (error.response.status === 403) {
                console.log('Error stripe payment')
                  setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                  setTimeout(()=>{window.location.href="/logout"}, 2000)
              } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
              }
          } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
          }
          setshowloader(false)
      }
      };
      
      useEffect(() => {
        fetch_admin_bookings();
        subscribeToTokenRefresh(() => {
          console.log("🔁 Token refreshed. Re-fetching experts...");
          fetch_admin_bookings();
        });
      }, []);


      useEffect(() => {
      }, [bookings]);




    return (
      <React.Fragment>
        <Col lg={12} className="order-lg-3 order-3">
        {alertMsgg.open && (
            <Alert
            color={alertMsgg.type === "success" ? "success" : "danger"}
            toggle={handleAlertMsggClose}
            style={{ fontWeight: "bold" }}
            >
            {alertMsgg.content}
            </Alert>
            )}
            <div className="loaderContainer" hidden={!showloader}>
            <div className="spinner">
              <div></div>  
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
            </div>
          </div>
          <Row>
            <Col xl={12}>
              <Card className="rounded-4">
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle tag="h4" className="mb-4">Latest Booking</CardTitle>
                    <Link to="/abookings" className="btn btn-primary">
                      View All
                    </Link>
                  </div>
                  <TableContainer
                    columns={columns}
                    data={bookings || []}
                    // isGlobalFilter={true}
                    isPagination={false}
                    // SearchPlaceholder="Search By Name..."
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers"
                    tableClass="table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>
      </React.Fragment>
    );
};

export default withRouter(LatestBooking);
